interface Item {
  createdAt: string;
}

export const sortNewest = (a: Item, b: Item) => {
  return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
};
